import * as Yup from 'yup';

export const validationSchema = (localization: any) => {
    const requiredFieldMessage = localization.form.requiredFieldMessage;
    return Yup.object().shape({
        shipmentId: Yup.string().required(requiredFieldMessage).nullable(),
        expirationDate: Yup.string().required(requiredFieldMessage).nullable()
    });
};
